var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage---Desktop",
    transform: "translate(-120.000000, -554.000000)",
    fill: "#3AF8CF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(120.000000, 503.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "correct",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12670156,53.7495575 C5.97397158,53.9103103 5.76559462,54 5.54913987,54 C5.33268511,54 5.12430815,53.9103103 4.97157817,53.7495575 L0.359012715,48.9222785 C-0.119670905,48.4213936 -0.119670905,47.6091773 0.359012715,47.1092315 L0.936574411,46.5047259 C1.41540765,46.0038409 2.1907255,46.0038409 2.66940912,46.5047259 L5.54913987,49.5181751 L13.3305909,41.3756637 C13.8094241,40.8747788 14.5854899,40.8747788 15.0634256,41.3756637 L15.6409873,41.9801693 C16.1196709,42.4810543 16.1196709,43.293114 15.6409873,43.7932164 L6.12670156,53.7495575 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green_check.f877a301a9c6998b5ea634c48e8a845a.svg";
export { ForwardRef as ReactComponent };